export default __webpack_public_path__ + "static/media/farmacia-img.05921fba.svg";